export default function strcharacterDiscode(str){
    // 加入常用解析
    
    str = str.replace(/&amp;/g, '&');
    str = str.replace(/&nbsp;/g, '\xa0');
    str = str.replace(/&quot;/g, '"');
    str = str.replace(/&#39;/g, "'");
    str = str.replace(/&apos;/g, "'");
    // str = str.replace(/&lt;/g, '‹');
    // str = str.replace(/&gt;/g, '›');

    str = str.replace(/&lt;/g, '<');
    str = str.replace(/&gt;/g, '>');
    str = str.replace(/&#8226;/g, '•');

    // str = str.replace(/img src="/g, 'img src="'+this.$imgDomain); 

    // console.log(str)
    return str;
}


// WEBPACK FOOTER //
// ./src/js/strcharacterDiscode.js